import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import reduxConfig from "./redux";
const root = ReactDOM.createRoot(document.getElementById("root"));
const { store, persistor } = reduxConfig();
root.render(
    <Provider store={store}>
        <App />
    </Provider>
);
